import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleUsers from './users/moduleDataList.js'
import moduleClients from './clients/moduleDataList.js'
import moduleServices from './services/moduleDataList.js'
import moduleAuth from './auth/moduleAuth.js'
import modulePosts from './posts/moduleDataList'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    users: moduleUsers,
    clients: moduleClients,
    services: moduleServices,
    posts: modulePosts
  },
  strict: false
})
